import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import InputValueProps from '../../../../../prop-types/input-value-props';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';

const TextAreaInput = ({ inputValueProps, onChange, label }) => {
  const { parameter } = inputValueProps;
  const [inputValue, setInputValue] = useState(parameter || '');
  const onValueChange = useCallback(
    (e) => {
      setInputValue(e?.target?.value);
    },
    [setInputValue],
  );
  const onBlur = useCallback(() => {
    onChange({
      [PARAMETER]: inputValue,
    });
  }, [onChange, inputValue]);
  const currentCount = inputValue.length;
  const allowedCount = 1000;
  return (
    <div className={classnames(style['text-area-component'], style['multi-control-row'])}>
      <div>{label}</div>
      <div className={style['text-area']}>
        <textarea
          className={style['text-area-input']}
          maxLength={allowedCount}
          onBlur={onBlur}
          onChange={onValueChange}
          value={inputValue}
        />
      </div>
      <div className={style.counter}>
        <FormattedMessage
          defaultMessage='{currentCount} / {allowedCount}'
          description='automationRules.textAreaCurrentCharacterCount'
          id='TXiteB'
          values={{ currentCount, allowedCount }}
        />
      </div>
    </div>
  );
};

TextAreaInput.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default TextAreaInput;
